export default __webpack_public_path__ + "static/icon-17-1-83e22b9ca45bb5d93f5a23326943d82e.png";